import Contents from '../Layouts/Contents'
import Credit from '../Layouts/Credits'
import styles from './index.module.scss'

const Configurations = () => {
  return (
    <div>
        <div className={styles.layout}>
            <Contents />
            <div className={styles.start}>
                <div>
                    <h1>Configurations</h1>
                    <p>Dreamvast supports a few options when it comes to customizing its behavior in your server.</p>
                    <p>You must have admin permissions to change any of these settings.</p>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h2>The /language + input command</h2>
                    <p>
                        Want to use Dreamvast in your native language? 
                        Server admins can set the language of Dreamvast in their server. 
                        Say, for instance, you want to change the language to Thai:
                    </p>
                </div>
                <div className={styles.markdown}>
                    <p>/language [vi]</p>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h2>The /control + toggle command</h2>
                    <p>
                        You can easily change the mode of control panel to enable or disable as you like, example:
                    </p>
                </div>
                <div className={styles.markdown}>
                    <p>/control [Enable / Disable]</p>
                </div>
                <div style={{ padding: '20px 0px' }}>
                    <h2>The /setup command</h2>
                    <p>
                    If you want a place where you can control your own music, this is the command for you, example:
                    </p>
                </div>
                <div className={styles.markdown}>
                    <p>/setup [Create / Delete]</p>
                </div>


            </div>
        </div>
        <Credit />
    </div>
  )
}

export default Configurations